var map = {
	"./Oracle.png": 1669,
	"./PHL03254.jpeg": 6824,
	"./avatar-aman.png": 6320,
	"./avatar-dmank.png": 6348,
	"./avatar-kristin.png": 8291,
	"./egeninc.png": 6312,
	"./egeninc_logo.jpeg": 4793,
	"./error.png": 9697,
	"./icon-app.svg": 6138,
	"./icon-design.svg": 2467,
	"./icon-dev.svg": 7846,
	"./icon-photo.svg": 2111,
	"./icon-quote.svg": 5047,
	"./manage-cloud.svg": 6202,
	"./portfolio-user.png": 1559,
	"./yahoo.png": 1947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;